module.exports = {
  CANCELLED: 'cancelled',
  PROPOSED: 'proposed',
  ACCEPTED: 'accepted',
};
